"use client";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
// import Image from "next/image";
import { Sidebar } from "primereact/sidebar";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FileUpload } from "primereact/fileupload";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import downvector from '../../../assets/images/DownVector.svg';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import TopLinesChart from "../charts/toplineschart";
import { color } from "echarts";
import { Button } from "antd";
import { fetchPop_Up_Absenteeism } from "../../../redux/slices/staffdetails";
import { useDispatch, useSelector } from "react-redux";
import LoaderContainer from "../../../components/LoaderContainer/LoaderContainer";
import { xlsxExport } from "../../../components/chartwrapper/excelDownload";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";

export default function StaffBottomBar(props) {
    const { visible, onHide, setActiveIndexList, title } = props;
    const [date, setDate] = useState(props?.date);
    const [fomatdate, setFormatDate] = useState(props?.date?.toLocaleDateString('en-US'));

    /* Redux State */
    const dispatch = useDispatch();
    const Pop_Up_Absenteeism = useSelector(state => state.staffdetails.Pop_Up_Absenteeism);
    const Pop_Up_AbsenteeismLoading = useSelector(state => state.staffdetails.Pop_Up_Absenteeismloading);

    // Filters
    const appliedfilter = useSelector(state => state.filter.appliedFilters);
    /* */

    useEffect(()=> {
        setDate(props?.date);
        setFormatDate(props?.date?.toLocaleDateString('en-US'));
    },[visible])

    /* API Call */
    useEffect(() => {
    if(visible){
        dispatch(fetchPop_Up_Absenteeism({
            "elasticQueryName": "Pop_Up_Absenteeism",
            "filters": appliedfilter,
            "dynamicColumns": [{ columnName: "#{date}", columnValue: fomatdate, "excludeKeyword": false }],
        }));
    }
    },[visible, fomatdate])
    /* */

    const handleChange = (e) => {
        const raw = e.value;
        const formattedDate = raw.toLocaleDateString('en-US');
        setFormatDate(formattedDate)
        setDate(e.value);
    };

    /* Date Restricted Logic */
    const thisweek_dates = useMemo(() => {
        const today = new Date();
        const firstday_of_week = new Date(today.setDate(today.getDate() - today.getDay())); // Sunday
        
        return Array.from({ length: 5 }, _ => new Date(firstday_of_week.setDate(firstday_of_week.getDate() + 1))).filter(date => date <= new Date());
    }, [])
    /* */

    const TableFilterTemplate = (options) => {
        return (
            <div className="relative flex items-center">
                <i className="pi pi-search absolute left-3 text-gray-500 text-sm"></i>
                <InputText
                    value={options.value}
                    onChange={(e) => options.filterCallback(e.target.value)}
                    placeholder="Search here"
                    className="pl-10 pr-3 py-1.5 border border-blue-300 rounded-md w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
            </div>
        );
    };

    return (
        <>
            <Sidebar
                visible={visible}
                onHide={onHide}
                position="bottom"
                className="bottomBar w-full bg-[#15181F]"
                blockScroll={true}
            >
                <div className="px-[30px] py-[15px] pb-1">
                    <div className="mb-[15px] flex justify-between">
                        <div className="text-[20px] text-[#fff] pl-[130px] pt-[10px] ">{title}</div>
                        <div className="flex gap-10 ">
                            <Calendar
                                value={date}
                                onChange={handleChange}
                                placeholder="Select a date"
                                // showButtonBar
                                disabledDays={[0,6]} // restrict Weekend
                                // enabledDates={thisweek_dates}
                                showIcon
                                dateFormat="m/d/yy"
                                className="bg-[#1b2a37] text-[#fff] rounded-md shadow"
                                inputClassName="w-full px-3 py-2 text-sm shadow-none text-white bg-[#1b2a37]"
                                panelClassName="custCalendar" 
                            />
                            <button onClick={() => xlsxExport({ filename: title, data: Pop_Up_Absenteeism })} className="bg-[#2E265A] text-[16px] leading-[16px] text-[#fff] rounded-full px-4 py-4 shadow whitespace-nowrap">Export XLS</button>
                        </div>
                    </div>
                    <div className="bg-[#1a2025cc]">
                        <div className="text-[16px] text-[#fff] leading-[24px] p-4 ">Detailed View of - Staff Absentees</div>
                        <div className="">
                        <LoaderContainer loading={Pop_Up_AbsenteeismLoading} height={'15rem'} width={'100%'}>
                            <DataTable
                                value={Pop_Up_Absenteeism}
                                className="staffTable"
                                scrollable
                                scrollHeight="430px"
                                paginator // Paginator Enable
                                rows={10} // Number of rows per page
                                rowsPerPageOptions={[5, 10, 25, 35]} // Options in Paginator Dropdown
                                style={{ width: "100%" }}
                                emptyMessage={
                                    <div className="flex justify-center">
                                        No Data Available.
                                    </div>
                                }
                                >
                                <Column
                                    field="STAFF_ID"
                                    header="Staff ID"
                                    // style={{ maxWidth: "4rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="STAFF_NAME"
                                    header="First Name"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="LAST_NAME"
                                    header="Last Name"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="ROLE"
                                    header="Role"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="LOCATION"
                                    header="Location"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="GENDER"
                                    header="Gender"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="ETHNICITY"
                                    header="Ethnicity"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="ABSENTEES"
                                    header="Absences"
                                    // style={{ minWidth: "8rem" }}
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                ></Column>
                                <Column
                                    field="NO_OF_DAYS"
                                    header="# of Days Absence (As of Today)"
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                    className="hltcolor"
                                    body={({NO_OF_DAYS})=> NO_OF_DAYS}
                                ></Column>
                                <Column
                                    field="PERCENTAGE"
                                    header="% of Days Absence (As of Today)"
                                    // style={{ minWidth: "8rem" }}
                                    body={(rowData) => rowData?.PERCENTAGE != null ? `${rowData.PERCENTAGE?.toFixed(2)}%` :  ''} 
                                    sortable
                                    filter
                                    showFilterMenuOptions={false}
                                    filterElement={TableFilterTemplate}
                                    filterMenuClassName="custfilter"
                                    className="hltcolor"
                                ></Column>
                            </DataTable>
                        </LoaderContainer>
                        </div>
                    </div>
                </div>
            </Sidebar>
        </>
    )
}